(function (module) {
    'use strict';
    module.directive('emBadge', function () {
        return {
            restrict: "EA",
            scope: {
                badgeType: '@'
            },
            templateUrl: 'directives/badge/em-badge.tpl.html',
            link: function (scope, element, attrs) {
                // if (scope.)
            }
        };
    });
}(angular.module('emarket.commons')));